import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { useMe } from '../../organisation/useMe';
import { caseAssignedStatusInternalApi, caseAssignmentInternalApi, caseStatusInternalApi } from '../../apis';
import { CASE_QUERY_KEY } from '../caseQueryActions';
import { CASE_NOTES_QUERY_KEY } from '../notes/caseNoteQueryActions';

export const CASE_STATUSES_QUERY_KEY = 'caseStatuses';

export const useQueryCaseStatuses = () => {
  const { currentOrganisation } = useMe();

  return useQuery({
    queryKey: [CASE_STATUSES_QUERY_KEY, currentOrganisation?.id],
    queryFn: async () => await caseStatusInternalApi.findAllCaseStatuses(),
    enabled: !!currentOrganisation?.id,
  });
};

export const useUpdateCaseStatus = (handle: string) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ code, note, draftId }: { code: string; note: string; draftId?: number }) => {
      return caseAssignedStatusInternalApi.updateCaseAssignedStatus({
        handle,
        internalApiUpdateCaseAssignedStatusRequest: { code, note, draftId },
      });
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [CASE_QUERY_KEY] });
      queryClient.invalidateQueries({ queryKey: [CASE_NOTES_QUERY_KEY] });
    },
  });
};

export const useAssignCase = (handle: string) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (assigneeId: number) => {
      return caseAssignmentInternalApi.assignCase({
        handle,
        internalApiAssignCaseRequest: { assigneeId },
      });
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [CASE_QUERY_KEY] });
    },
  });
};

export const useUnassignCase = (handle: string) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: () => {
      return caseAssignmentInternalApi.unassignCase({ handle });
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [CASE_QUERY_KEY] });
    },
  });
};
